import { useState, useEffect } from 'react';
import { globalUserPreferences } from '../services/globalization/userPreferenceContext';
import { dictionaries } from './dictionaries';

type LanguageCode = 'en' | 'fr' | 'de';

export function useTranslation() {
  const [lang, setLang] = useState<LanguageCode>(
    (globalUserPreferences.getPreferences().preferredLanguage as LanguageCode) || 'en'
  );

  useEffect(() => {
    const unsubscribe = globalUserPreferences.subscribe((prefs) => {
      setLang((prefs.preferredLanguage as LanguageCode) || 'en');
    });
    return unsubscribe;
  }, []);

  const t = (key: string) => {
    const dict = dictionaries[lang] || dictionaries['en'];
    return dict[key] || dictionaries['en'][key] || key;
  };

  return { t, lang };
}
